/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Link, Modal, TextContainer, TextStyle, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { ExternalMinor } from '@shopify/polaris-icons';
import { URL } from 'src/constants/links';

type Props = {
  active: boolean,
  removing: boolean,
  handleContact: () => void,
  handleSelectAnother: () => void
};

type ComposedProps = Props & WithI18nProps;

class WarningOS10Modal extends Component<ComposedProps> {
  render() {
    const { i18n, active, isChooseText } = this.props;

    return (
      <Modal
        open={active}
        onClose={this.handleSelectAnother}
        title={i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_title')}
        secondaryActions={{
          content: i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_btn_contact'),
          onAction: this.handleContact
        }}
        primaryAction={[
          {
            content: isChooseText ? i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_btn_choose') : i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_btn_select'),
            onAction: this.handleSelectAnother
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <TextStyle>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_content_onboarding', {
                l: (
                  <span className="img-new-tab">
                    <Link external url={URL['ThemeSetupV3Doc_shopify_guide']}>
                      {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_content_onboarding_l')}
                      <Icon source={ExternalMinor} color="interactive" />
                    </Link>
                  </span>
                )
              })}
              <p style={{ marginTop: '12px' }}>
              {i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.warning_OS10_content_onboarding_2')}
              </p>
            </TextStyle>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleContact = () => {
    this.props.handleContact();
  };

  handleSelectAnother = () => {
    this.props.handleSelectAnother();
  };
}

export default withI18n()(WarningOS10Modal);
